import withModal from 'src/hoc/withModal'

import LayoutTypesDialog from './LayoutTypesDialog'

export default withModal(LayoutTypesDialog)
